import { render, staticRenderFns } from "./FormPropertyManager.vue?vue&type=template&id=64a56ed9&scoped=true"
import script from "./FormPropertyManager.vue?vue&type=script&lang=js"
export * from "./FormPropertyManager.vue?vue&type=script&lang=js"
import style0 from "./FormPropertyManager.vue?vue&type=style&index=0&id=64a56ed9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a56ed9",
  null
  
)

export default component.exports